export default __webpack_public_path__ + "static/media/Bank-settings.776d32bc.svg";